app.directive('clock', [function() {
    return {
        restrict: "EA",
        transclude: true,
        template: "<ng-transclude></ng-transclude>",
        scope: {
            clock: "=",
            dateFormat: "@",
            timeFormat: "@"
        },
        link: function(scope, elem, attrs) {
            var clock_date,
                clock_time,
                time_string,
                date_string;

            if(!scope.dateFormat) {
                scope.dateFormat = "MMMM Do YYYY";
            }

            if(!scope.timeFormat) {
                scope.timeFormat = "h:mm:ss A";
            }

            //Get the necessary date and time elements
            clock_date = $('#clock_date_' + scope.clock.id);
            clock_time = $('#clock_time_' + scope.clock.id);

            setInterval(function() {
                date_string = moment().format(scope.dateFormat);
                time_string = moment().format(scope.timeFormat);
                clock_date.html(date_string);
                clock_time.html(time_string);
            }, 1000)
        }
    }
}]);